import { AccountAvatarComponent, AccountAvatarController } from './account_avatar/account_avatar';
import { AppSupportComponent, AppSupportController } from './app_support/app_support';
import { FeedContainerComponent, FeedContainerController } from './feed_container/feed_container';
import { PersonalGreetingComponent, PersonalGreetingController } from './personal_greeting/personal_greeting';
import { QuickAddComponent, QuickAddController } from './quick_add/quick_add';
import { SelfAlertDialogComponent, SelfAlertDialogController } from './self_alert_dialog/self_alert_dialog';
import {
  StudentFeedbackDialogComponent,
  StudentFeedbackDialogController
} from './student_feedback_dialog/student_feedback_dialog';

angular
  .module('capability-ng-priority-feed')
  .controller('AccountAvatarController', AccountAvatarController)
  .component('accountAvatar', new AccountAvatarComponent())
  .controller('AppSupportController', AppSupportController)
  .component('appSupport', new AppSupportComponent())
  .controller('FeedContainerController', FeedContainerController)
  .component('feedContainer', new FeedContainerComponent())
  .controller('PersonalGreetingController', PersonalGreetingController)
  .component('personalGreeting', new PersonalGreetingComponent())
  .controller('QuickAddController', QuickAddController)
  .component('quickAdd', new QuickAddComponent())
  .controller('SelfAlertDialogController', SelfAlertDialogController)
  .component('selfAlertDialog', new SelfAlertDialogComponent())
  .controller('StudentFeedbackDialogController', StudentFeedbackDialogController)
  .component('studentFeedbackDialog', new StudentFeedbackDialogComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/priority_feed_components_module.ts